<template>
  <div class="flex justify-between mb-2">
    <div class="flex gap-[16px] w-[50%]">
      <div v-if="hasDropdown" class="w-48 mr-4">
        <Dropdown
          :options="dropdownOptions"
          :hasSearch="true"
          :isOverlay="true"
          buttonText="Choose an option"
          :tableFilter="true"
          class="ml-4"
          @select="handleSelect"
        >
          <template #icon>
            <img src="@/assets/svg/buildings-2.svg" alt="" />
          </template>
        </Dropdown>
      </div>
      <div>
        <TableFilterVue popoverClass="" />
      </div>

      <div>
        <TableExportVue :data="[]" />
      </div>
      <div class="w-[35%]">
        <EpumpInputVue
          :label="''"
          :passwordRevealToggle="false"
          :clearSearch="false"
          :placeholder="'Search'"
          :status="'tableInput'"
          :type="'text'"
          :forgotPassword="false"
          :validation="false"
          @input="handleinput"
          ><img src="@/assets/svg/search.svg"
        /></EpumpInputVue>
      </div>
    </div>

    <div class="flex items-center gap-[16px]">
      <img
        @click="refresh"
        class="cursor-pointer"
        src="@/assets/svg/refresh.svg"
      />
      <div>
        <paginationVue />
      </div>
    </div>
  </div>
</template>

<script>
import paginationVue from "../pagination/pagination.vue";
import TableFilterVue from "./TableFilter.vue";
import EpumpInputVue from "../Inputs/EpumpInput.vue";
import Dropdown from "@/components/UI/dropdown/dropdown.vue";
import TableExportVue from "./TableExport.vue";
export default {
  components: {
    paginationVue,
    TableFilterVue,
    EpumpInputVue,
    TableExportVue,
    Dropdown,
  },
  props: {
    hasDropdown: {
      type: Boolean,
      required: false,
    },
    dropdownOptions: {
      type: Array,
      required: false,
      default: [],
    },
  },
  methods: {
    handleinput(value) {
      this.$emit("search", value);
    },
    handleSelect(value) {
      this.$emit("select", value);
    },
  },
};
</script>

<style></style>
